import { observer } from 'mobx-react-lite';
import StepMenuGroup from './StepMenuGroup';

interface Props {
    position: string;
    currentTab: number;
    permitTypeId: number;
}

export default observer(function StepMenu({ 
    position, 
    currentTab,
    permitTypeId
 }: Props) {
    return (
        <>
            {position === 'top' && (
                <StepMenuGroup 
                    fluid={true}
                    attached='top'
                    currentTab={currentTab}
                    permitTypeId={permitTypeId}
                />
            )}

            {position === 'bottom' && (
                <StepMenuGroup 
                    fluid={true}
                    attached='bottom'
                    currentTab={currentTab}
                    permitTypeId={permitTypeId}
                />
            )}
        </>
    )
})